import { Components, Theme } from '@mui/material/styles';

export const MuiPickersDay: Components<Theme>['MuiPickersDay'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      width: theme.spacing(36),
      height: theme.spacing(36),
    }),
  },
};

export const MuiPickersToolbar: Components<Theme>['MuiPickersToolbar'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      maxWidth: theme.spacing(160),
      padding: theme.spacing(16),
    }),
  },
};
